<template>
  <v-form class="pt-2">
    <v-row>
      <v-col cols="12" md="6" class="py-0">
        <gg-text-field outlined
                       ref="emailField"
                       label="Email Address"
                       dense
                       placeholder="ex. yourname"
                       autocomplete="new-password"
                       v-model="model.email"
                       v-validate="'required'"
                       name="Email"
                       :error-messages="errors.collect('Email')">
          <template v-slot:append>
            <div v-if="!isMobileDevice" class="append-bg">
              <domain-select no-label
                             hide-details
                             flat
                             solo
                             v-model="model.selectedDomain"
                             prepend-inner-icon="mdi-at"
                             :style="{ width: `${domainWidth}px`, minWidth: '180px', maxWidth: `${domainMaxWidth}px` }"
              ></domain-select>
            </div>
          </template>
        </gg-text-field>
      </v-col>
      <v-col v-if="isMobileDevice" cols="12" class="py-0">
        <v-scale-transition>
          <domain-select outlined
                         v-model="model.selectedDomain"
                         label="Select a Domain"
                         :prepend-inner="false"></domain-select>
        </v-scale-transition>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <gg-input-label>Password</gg-input-label>
        <compact-password outlined
                          autocomplete="new-password"
                          v-validate="'required'"
                          data-vv-name="password"
                          data-vv-as="Password"
                          :error-messages="errors.collect('password')"
                          with-generator
                          v-model="model.password"></compact-password>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-switch color="green"
                  class="mt-0"
                  label="Send welcome email with mail client configuration instructions."
                  v-model="sendSettings"></v-switch>
      </v-col>
    </v-row>
    <gg-btn primary :loading="loading" @click="addEmail">
      Create account
    </gg-btn>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'CreateEmail',
  components: {
    DomainSelect, CompactPassword
  },
  data () {
    return {
      model: {
        email: '',
        selectedDomain: '',
        password: '',
        quota: '512'
      },
      sendSettings: true,
      loading: false,
      domainMaxWidth: '250px'
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    accountName () {
      return `${this.SessionProfile.firstname.toLowerCase()}${this.SessionProfile.lastname.toLowerCase()}`
    },
    domainWidth () {
      const length = this.model.selectedDomain ? this.model.selectedDomain.length : 18
      return length * 12 // 12 px per symbol
    },
    isMobileDevice () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  methods: {
    ...mapActions({
      createEmail: 'email/createEmail',
      sendClientSettings: 'email/sendClientSettings',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    listenPassword (payload) {
      this.model.password = payload
    },
    async addEmail () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      const data = {
        email: this.model.email,
        password: this.model.password,
        domain: this.model.selectedDomain,
        quota: this.model.quota,
        username: this.$route.query.user,
      }
      try {
        await this.createEmail(data)
        if (this.sendSettings) {
          const settings_data = {
            uapi_module: 'Email',
            uapi_function: 'dispatch_client_settings',
            account: `${this.model.email}@${this.model.selectedDomain}`
          }
          await this.sendClientSettings(settings_data)
        }
        this.clearModel()
        this.reportSuccess('Email was created successfully')
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    clearModel () {
      this.model.email = ''
      this.model.password = ''
      this.model.quota = '512'
      this.sendSettings = true
      this.$validator.reset()
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.domainMaxWidth = this.$refs.emailField.$el.clientWidth * 0.6
    })
  }
}
</script>
